invHdApp.
  factory('Ticket', ['$http', function ($http) {
    return {
      all: function (data) {
        return $http.post('api/tickets', data);
      },
      get: function (id) {
        return $http.get('api/ticket/' + id);
      },
      new: function (id) {
        return $http.get('api/new-ticket');
      },
      delete: function (id) {
        return $http.delete('api/delete-ticket/' + id);
      },
      save: function (data) {
        return $http.post('api/save-ticket', data);
      },
      update: function (data) {
        return $http.post('api/update-ticket', data);
      },
      addConversation: function (data) {
        return $http.post('api/add-conversation', data);
      },
      closeTicket: function (data) {
        return $http.post('api/close-ticket', data);
      },
    };
  }]);